/**
 * Scopes
 */
const sharedScopes: string[] = [
  // e.g. "https://fabrikamb2c.onmicrosoft.com/helloapi/demo.read"
]

// Scopes you add will be prompted for user consent during sign-in.
// By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
// For more information about OIDC scopes, visit:
// https://docs.microsoft.com/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
export const signInScopes: string[] = [
  ...sharedScopes,
]

// Scopes you add here will be used to request a token from Azure AD B2C to be used for accessing a protected resource.
// To learn more about how to work with scopes and resources, see:
// https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
export const b2cTokenRequestScopes: string[] = [
  ...sharedScopes,
]
